import React, { useEffect, useMemo, useState } from "react"
import { Modal } from "react-bootstrap"
import { toast } from "react-toastify"

import { Button, Select } from "components"
import { getBulkSmsTemplates, sendPaymentFollowUpSms } from "services"
import classes from "./PaymentFollowUpSmsModal.module.scss"

const defaultTemplate = {
  value: "default",
  label: "یادآوری پرداخت و ارسال لینک",
  text: "سلام {{customerName}} عزیز، سفارش شماره {{orderCode}} شما در {{businessName}} هنوز پرداخت نشده است. برای تکمیل سفارش از لینک زیر استفاده کنید:\n{{paymentLink}}"
}

const PaymentFollowUpSmsModal = ({ order, show, onHide, onSent }) => {
  const [templates, setTemplates] = useState([])
  const [selectedTemplate, setSelectedTemplate] = useState(defaultTemplate)
  const [text, setText] = useState(defaultTemplate.text)
  const [loading, setLoading] = useState(false)
  const [sending, setSending] = useState(false)

  const options = useMemo(() => [
    defaultTemplate,
    ...templates.map(template => ({
      value: template._id,
      label: template.title,
      text: template.text
    }))
  ], [templates])

  useEffect(() => {
    if (!show) return

    setSelectedTemplate(defaultTemplate)
    setText(defaultTemplate.text)
    setLoading(true)

    getBulkSmsTemplates({ branchId: order.branchId })
      .then(response => setTemplates(response || []))
      .catch(() => {
        setTemplates([])
        toast.error("دریافت قالب‌های پیامکی ناموفق بود")
      })
      .finally(() => setLoading(false))
  }, [show, order.branchId])

  const handleTemplateChange = option => {
    setSelectedTemplate(option)
    setText(option?.text || "")
  }

  const handleSend = async () => {
    if (!text.trim()) {
      toast.error("متن پیامک را وارد کنید")
      return
    }

    setSending(true)
    try {
      const response = await sendPaymentFollowUpSms(order._id, text.trim())
      onSent?.(response)
      toast.success("پیامک پیگیری پرداخت ارسال شد")
      onHide()
    } catch (error) {
      toast.error("ارسال پیامک پیگیری پرداخت ناموفق بود")
    } finally {
      setSending(false)
    }
  }

  return (
    <Modal show={show} onHide={onHide} backdrop="static" centered>
      <div className={classes.container}>
        <h4 className={classes.title}>ارسال پیامک پیگیری پرداخت</h4>

        <div className={classes.customer}>
          گیرنده: {order.customerFullName || "مشتری"} — {order.customerMobilePhone}
        </div>

        <Select
          label="قالب پیامک"
          value={selectedTemplate}
          options={options}
          isLoading={loading}
          isDisabled={loading || sending}
          onChange={handleTemplateChange}
        />

        <label className={classes.label}>متن پیامک</label>
        <textarea
          className={classes.textarea}
          value={text}
          maxLength={1000}
          disabled={sending}
          onChange={event => setText(event.target.value)}
        />

        <div className={classes.hint}>
          متغیرها: {"{{customerName}}"} نام مشتری، {"{{orderCode}}"} کد سفارش، {"{{businessName}}"} نام کسب‌وکار و {"{{paymentLink}}"} لینک پرداخت. لینک در صورت نبودن، خودکار افزوده می‌شود.
        </div>

        <div className={classes.footer}>
          <Button color="danger" disabled={sending} onClick={onHide}>لغو</Button>
          <Button color="success" loading={sending} disabled={loading} onClick={handleSend}>
            ارسال پیامک
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default PaymentFollowUpSmsModal
